import { ApiError } from './http.js';

/**
 * The API's own message for a failed request, or the caller's fallback.
 *
 * Three surfaces had written this by hand — the connect panel, `MembersTab`, and
 * `GrantEditor` — byte-identical apart from which copy constant they fell back
 * to. The invite form would have been the fourth, and Article 3 is explicit:
 * one way to do a thing.
 *
 * **Why prefer the server's string at all**, when most of this app shows a
 * single generic line per surface: several refusals here name something the
 * admin can actually *do*. CON-8 says which domain is not allow-listed and to
 * contact Blue Partner. CON-10 says to designate another admin first. PERM-2
 * says to remove someone's admin rights before setting space access. USR-2 names
 * the domain an address has to be on. A generic "reload and try again" throws
 * away the useful half of every one of those.
 *
 * **The fallback is a parameter rather than a default**, because there is no
 * honest general one — each surface's is written for what the reader was in the
 * middle of doing, and a shared "Something went wrong" would quietly replace
 * four sentences that say more.
 *
 * Note what it does *not* do: `ApiError.message` is never shown. That string
 * names the request path and is written for whoever is reading a stack trace.
 */
export function messageFrom(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    const body = error.body as { error?: { message?: unknown } } | null;
    const message = body?.error?.message;
    if (typeof message === 'string' && message !== '') return message;
  }

  return fallback;
}
